var _style, _circle, _path, _g, _g2, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#0052B4;}\n\t.st2{fill:#D80027;}\n\t.st3{fill:#FFDA44;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C114.6,0,0,114.6,0,256c0,31.3,5.6,61.3,15.9,89h480.2c10.3-27.7,15.9-57.7,15.9-89 C512,114.6,397.4,0,256,0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256,0C145.9,0,52.1,69.5,15.9,167h480.2C459.9,69.5,366.1,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.2,144.7v127.7c0,72.6,94.9,94.9,94.9,94.9S256,345,256,272.4V144.7L66.2,144.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.4,167h111.3v-44.5l-22.3,11.1l-33.4-33.4l-33.4,33.4l-22.3-11.1V167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.7,290.2l-72.3-72.3L89,290.2l23.6,23.6l48.7-48.7l48.7,48.7L233.7,290.2z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.7,222.6H200c1.9-3.3,3-7.1,3-11.1c0-12.3-10-22.3-22.3-22.3c-8.5,0-15.9,4.8-19.6,11.8 c-3.8-7-11.1-11.8-19.6-11.8c-12.3,0-22.3,10-22.3,22.3c0,4.1,1.1,7.9,3,11.1H89c0,12.3,10.7,22.3,23,22.3h-0.7 c0,12.3,10,22.3,22.3,22.3c0,10.9,7.8,19.9,18.1,21.9l-17.5,39.6c8.4,3.4,17.6,5.3,27.2,5.3s18.8-1.9,27.2-5.3L171.1,289 c10.3-1.9,18.1-11,18.1-21.9c12.3,0,22.3-10,22.3-22.3h-0.7C223,244.9,233.7,234.9,233.7,222.6L233.7,222.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/rs.ed0d67bb46177663b372faa7a76e2164.svg";
export { ForwardRef as ReactComponent };